import ReactDOM from 'react-dom';
import 'shared/assets/css/index.scss';
import { App } from './components/App/components/App';

ReactDOM.render(<App />, document.getElementById('root'));
